export default function ({ $auth, $graphql }) {
  if (!$auth.strategy.token.status().valid()) return

  $graphql.cms.setHeaders({
    authorization: $auth.strategy.token.get(),
  })
}
